import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null); // null=checking, false=none, object=auth
  const [token, setToken] = useState(() => localStorage.getItem("aak_admin_token"));

  useEffect(() => {
    if (!token) {
      setAdmin(false);
      return;
    }
    api
      .get("/auth/me", { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setAdmin(r.data))
      .catch(() => {
        localStorage.removeItem("aak_admin_token");
        setToken(null);
        setAdmin(false);
      });
  }, [token]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("aak_admin_token", data.token);
    setToken(data.token);
    setAdmin(data.user);
    return data;
  };

  const logout = () => {
    localStorage.removeItem("aak_admin_token");
    setToken(null);
    setAdmin(false);
  };

  const authHeader = () => ({ Authorization: `Bearer ${token}` });

  return (
    <AuthContext.Provider value={{ admin, token, login, logout, authHeader }}>
      {children}
    </AuthContext.Provider>
  );
};
